import { useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { useNavigation } from "../../../hooks/useNavigation";

export const useSmsSendComplete = () => {
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { password, phoneNumber, token, isActivation } = state ?? {};

  useEffect(() => {
    if (!phoneNumber || !token) return navigateToPage(PageRoutes.LOGIN);
  }, [phoneNumber, token]);

  const maskedPhoneNumber = useMemo(() => {
    return `*** **** ${phoneNumber?.slice(-4)}`;
  }, [phoneNumber]);

  const handleSmsSendComplete = useCallback(() => {
    navigateToPage(PageRoutes.SMS_REGISTRATION, false, {
      password,
      phoneNumber,
      token,
      isActivation,
    });
  }, []);

  return { maskedPhoneNumber, handleSmsSendComplete };
};
